import React from 'react'
import cx from 'classnames'
import { useDevice } from 'device'

import StorylyComponent, { type StorylyComponentProps } from './components/StorylyComponent/StorylyComponent'

import backgroundImageMobile from './images/bg-mobile.jpg'
import backgroundImageDesktop from './images/bg-desktop.jpg'


type StorylySectionProps = StorylyComponentProps & {
  className?: string
}

const StorylySection: React.FC<StorylySectionProps> = ({ className, instance }) => {
  const { isMobile } = useDevice()

  return (
    <div className={cx(className, 'relative py-32')}>
      <img
        className="absolute top-0 h-full w-full object-cover"
        src={isMobile ? backgroundImageMobile : backgroundImageDesktop}
      />
      <StorylyComponent instance={instance} />
    </div>
  )
}

export default StorylySection
